import { render, staticRenderFns } from "./taxlawSearch.vue?vue&type=template&id=40992d1c&scoped=true"
import script from "./taxlawSearch.vue?vue&type=script&lang=js"
export * from "./taxlawSearch.vue?vue&type=script&lang=js"
import style0 from "./taxlawSearch.vue?vue&type=style&index=0&id=40992d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40992d1c",
  null
  
)

export default component.exports